import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, TextField } from '../../../../../components';



export const AddDetailsReceiptForm = ({ onClose, onAdd, id }) => {

    const methods = useForm();
    const { reset } = methods

    const rowDone = 'okay'
    const { handleSubmit, setValue, watch } = methods;
    const formSubmitHandler = (formValues) => {
        onAdd({ ...formValues, id, rowDone });
        reset()

    };
    return (
        <Stack spacing={1} sx={{ height: '100%' }}>
            <Stack
                padding={1.5}
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="grey.300"
            >
                <Typography variant="h4" fontWeight="bold">
                    Add Details
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon color="error" fontSize="large" />
                </IconButton>
            </Stack>
            <FormProvider
                sx={{ height: '100%', overflow: 'auto' }}
                methods={methods}
                onSubmit={handleSubmit(formSubmitHandler)}
            >
                <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Adj Amt</Typography>
                                <TextField
                                    sx={{ flex: 1 }}
                                    name="adj_amt"
                                    placeholder="Enter Adjustment Amount"
                                />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>TDS</Typography>
                                <TextField sx={{ flex: 1 }} name="tds" placeholder=" Enter TDS" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>TCS</Typography>
                                <TextField sx={{ flex: 1 }} name="tcs" placeholder="Enter TCS" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Rebate & Dis</Typography>
                                <TextField sx={{ flex: 1 }} name="rebate_dis" placeholder="Enter Rebate & Dis" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Total Adj</Typography>
                                <TextField sx={{ flex: 1 }} name="total_adj" placeholder=" Enter Total Adjustment" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                                <Button variant="contained" type="submit"   >
                                    Add
                                </Button>
                                <Button variant="outlined" onClick={onClose} color="error">
                                    Close
                                </Button>
                            </Stack>
                        </Box>

                    </Grid>
                </Grid>
            </FormProvider>
        </Stack>
    );
};
